import settingService from './service';

const state = {
  all: [],
  setting: {}
};

const getters = {};

const actions = {
  getAll({ commit }) {
    settingService.getAll().then(result => {
      commit('setSettings', result.data);
    });
  },
  getById({ commit }, id) {
    settingService.getById(id).then(result => {
      commit('setSetting', result.data);
    });
  },
  update({ commit }, payload) {
    
    return settingService.update(payload).then(result => {
      commit('updateSetting', result.data);
    });
  },
  create({ commit }, setting) {
    settingService.create(setting).then(result => {
      commit('createSetting', result.data);
    });
  }
};

const mutations = {
  setSettings(state, settings) {
    state.all = settings;
  },
  setSetting(state, setting) {
    state.setting = setting;
  },
  updateSetting(state, setting) {
    state.setting = setting;
  },
  createSetting(state, setting) {
    state.setting = setting;
  }
};

const settings = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default settings;
